import React, {lazy, useEffect} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import Login from "../views/login/Login";
import {AppDispatch, useSelector} from "../redux/store";
import PageWrapper from "../layouts/full/logbook/PageWrapper";
import Logout from "../views/logout/Logout";
import LogbookHome from "../views/logbook/urunler/LogbookHome";
import {logout} from "../redux/actions/authActions";
import Gunsonu from "../views/logbook/gunsonu/Gunsonu";
import Yonetim from "../views/logbook/yonetim/Yonetim";
import KisiDetay from "../views/logbook/yonetim/kisiler/KisiDetay";
import Takvim from "../views/logbook/takvim/Takvim";
import MenuYonetimiLayout from "../views/logbook/menuYonetimi/MenuYonetimiLayout";

const LandingPage = Loadable(lazy(() => import('../views/landingPage/LandingPage')));

const AuthCheck = () => {
    const exp = useSelector(state => state.auth.exp);
    const dispatch = AppDispatch();

    useEffect(() => {
        if (exp != null && exp <= new Date().valueOf() / 1000) {
            dispatch(logout());
        }
    }, [exp, dispatch]);

    return null;
};

const Routes = () => {
    const accessToken: any = useSelector((state) => state.auth.accessToken);
    const userId = useSelector((state: any) => state.auth.user_id);

    return React.useMemo(() => {
        const publicRoutes: any[] = [
            {
                path: '/Menu',
                element: <><AuthCheck/><Outlet/></>,
                children: [
                    {
                        path: '/Menu',
                        element: <LandingPage/>,
                    },
                    {
                        path: '/Menu/:kategori',
                        element: <LandingPage/>,
                    }
                ],
            },
            {
                path: '*',
                element: <Navigate to="/Menu"/>,
            },
        ];

        return !accessToken ? [...publicRoutes,
            {
                path: '/Logbook',
                element: <Outlet/>,
                children: [
                    {
                        path: '/Logbook',
                        element: <Login/>,
                    },
                    {
                        path: '*',
                        element: <Navigate to="/Logbook"/>,
                    }
                ]
            },
            {
                path: '/PortRoyal',
                element: <LandingPage/>
            },
        ] : [...publicRoutes,
            {
                path: '/Logbook',
                element: <><AuthCheck/><PageWrapper/></>,
                children: [
                    {
                        path: '/Logbook',
                        element: <LogbookHome/>,
                    },
                    {
                        path: '/Logbook/profil',
                        element: <KisiDetay kisiId={userId || 0} isProfil={true}/>,
                    },
                    {
                        path: '/Logbook/yonetim',
                        element: <Yonetim/>,
                    },
                    {
                        path: '/Logbook/yonetim/:tab',
                        element: <Yonetim/>,
                    },
                    {
                        path: '/Logbook/menu-yonetimi',
                        element: <MenuYonetimiLayout/>,
                    },
                    {
                        path: '/Logbook/menu-yonetimi/:tab',
                        element: <MenuYonetimiLayout/>,
                    },
                    {
                        path: '/Logbook/gunsonu',
                        element: <Gunsonu/>,
                    },
                    {
                        path: '/Logbook/takvim',
                        element: <Takvim/>,
                    },
                    {
                        path: '/Logbook/logout',
                        element: <Logout/>,
                    },
                    {
                        path: '*',
                        element: <Navigate to="/Logbook"/>,
                    }
                ],
            },
            {
                path: '/PortRoyal',
                element: <PageWrapper/>,
                children: []
            },
        ];
    }, [accessToken]);
}

export default Routes;
